import React from "react";

const AllergyList = ({ items = [], id = "" }) => {
    return (
        <div>
            {items.map(({ name }, index) => (
                <span key={index} className="badge badge-pill fade-in badge-warning margin-right-10">
                    {name}
                </span>
            ))}
            {items.length < 1 && (
                <div className="text-center">
                    <h5 className="text-success">No Allergy!</h5>
                </div>
            )}
        </div>
    );
};

export default AllergyList;
